<!--// 保单详情卡片-->
<template>
  <!-- 保单号 -->
  <div class="detailsNumber">
    <!-- 头部 -->
    <div class="numberTh">
      <div class="baodanId">{{ baodanDetail.policyNo }}</div>
      <div class="name">保单号</div>
    </div>
    <!-- 分割线 -->
    <el-divider></el-divider>
    <!-- 作物图片信息 -->
    <div class="contImg">
      <div class="zuoweImg">
        <img :src="baodanDetail.cropGroupImgUrl" alt="" />
      </div>
      <div class="name">{{ baodanDetail.cropGroupName }}</div>
    </div>

    <!-- 信息 -->
    <div class="messageBaodan">
      <div class="itemMess">
        <span class="title"> 自缴保费&nbsp;:</span>
        <span class="resUser"
          >{{ baodanDetail.selfPremiumTotal }} 元
          <span>({{ baodanDetail.selfPremiumUnit }} 元/亩)</span>
        </span>
      </div>
      <div class="itemMess">
        <span class="title"> 种植面积&nbsp;:</span>
        <span class="resUser">{{ baodanDetail.totalLandAcre }}亩</span>
      </div>
      <div class="itemMess">
        <span class="title"> 险种名称&nbsp;:</span>
        <span class="resUser">{{ baodanDetail.coInsureVO.insureName }}</span>
      </div>
      <div class="itemMess">
        <span class="title"> 承保机构&nbsp;:</span>
        <span class="resUser">{{ baodanDetail.coInsureCompanyVO.name }}</span>
      </div>
      <div class="itemMess">
        <span class="title"> 种植时间&nbsp;:</span>
        <span class="resUser">{{
          baodanDetail.coFarmInsureOrderLandVOList[0].plantStartDate
            | formatDate("yyyy-MM-dd")
        }}</span>
      </div>
      <div class="itemMess">
        <span class="title"> 起保时间&nbsp;:</span>
        <span class="resUser">{{
          baodanDetail.insureEffectiveStartDate | formatDate("yyyy-MM-dd")
        }}</span>
      </div>
      <div class="itemMess">
        <span class="title"> 终保时间&nbsp;:</span>
        <span class="resUser">{{
          baodanDetail.insureEffectiveEndDate | formatDate("yyyy-MM-dd")
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaodanCar",
  props: {
    baodanDetail: {
      type: [Object, Array],
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.detailsNumber {
  box-sizing: border-box;
  width: 425px;
  height: 670px;
  margin: 50px 90px 0 120px;
  background-color: #c4c4c4;
  background: url("~@/assets/images/insuranceImg/baodanBj.png");
}

.el-divider--horizontal {
  background-color: #f5ebdf;
}

.numberTh {
  display: flex;
  flex-direction: column;
  margin: 10px 0 10px;
}
.baodanId {
  font-size: 28px;
  font-weight: 600;
  color: #7c6e5f;
}
.contImg {
  padding-top: 16px;
}
.zuoweImg {
  margin: 0 auto;
  overflow: hidden;
  width: 84px;
  height: 84px;
  border-radius: 50%;
  img {
    width: 100%;
    height: 100%;
  }
}

.name {
  margin-top: 10px;
  color: #ad9b88;
}

.messageBaodan {
  color: #7c6e5f;
  text-align: left;
  margin-top: 55px;

  .itemMess {
    line-height: 24px;
    margin: 20px 0;
  }
  .resUser {
    padding-left: 20px;
    color: #ad9b88;
  }
}
</style>
